import { render, staticRenderFns } from "./AddVariant.vue?vue&type=template&id=19925e0b&"
import script from "./AddVariant.vue?vue&type=script&lang=js&"
export * from "./AddVariant.vue?vue&type=script&lang=js&"
import style0 from "./AddVariant.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports